import React from 'react'
import { AppBar, IconButton, Toolbar, Typography } from '@mui/material'
import { drawerWidth } from 'src/utils/constants'
import MenuIcon from '@mui/icons-material/Menu'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'src/store'
import { handleDrawerToggle } from 'src/store/features/common/commonSlice'
import styles from './index.module.scss'

const Header = () => {
  const dispatch = useDispatch<AppDispatch>()
  return (
    <AppBar
      position='fixed'
      className={styles.header}
      sx={{
        width: { sm: `calc(100% - ${drawerWidth}px)` },
        ml: { sm: `${drawerWidth}px` },
       
      }}
    >
      <Toolbar>
        <IconButton
          color='inherit'
          aria-label='open drawer'
          edge='start'
          onClick={() => dispatch(handleDrawerToggle())}
          sx={{ mr: 2, display: { sm: 'none' } }}
        >
          <MenuIcon />
        </IconButton>
        {/* <Typography variant='h6' noWrap component='div'>
          Responsive drawer
        </Typography> */}
      </Toolbar>
    </AppBar>
  )
}

export default Header
